import React from 'react';
import LeaseCustomField from './LeaseCustomField.js.jsx';
import styles from '../../../stylesheets/management_site/tenantForm.module.scss';

const LeaseCustomFieldGroup = ({
  groupName,
  groupId,
  fields,
  basePath,
  startIndex,
  isExpanded,
  onToggle,
}) => {
  if (!fields || fields.length === 0) return null;

  return (
    <div
      id={`${groupId}-panel`}
      className={`custom-field-groups-panel mdc-expansion-panel edit ${styles.customFieldGroup}`}
    >
      <div className={`mdc-expansion ${isExpanded ? 'open' : 'closed'}`}>
        <div
          className="mdc-expansion__header pm-expansion-header--grey group-header"
          onClick={onToggle}
        >
          <span className="mdc-expansion__item">{groupName}</span>
          <div className="pm-flex-grow"></div>
        </div>
        <div
          id={`${groupId}-panel__body`}
          className={`mdc-expansion__body ${isExpanded ? styles.customFieldGroupExpanded : styles.customFieldGroupCollapsed}`}
        >
          <div className="mdc-expansion__body--inner">
            <div
              id={`${groupId}-panel__content`}
              className={`group-expansion-content mdc-expansion__content ${styles.customFieldGroupBody}`}
            >
              <div
                id={`request-${groupId}-panel`}
                className={`inner-custom-field-group-panel panel pm-flex ${styles.customFieldGroupPanel}`}
              >
                <div
                  className={`pm-flex pm-flex-2 ${styles.customFieldGroupContent}`}
                >
                  {fields.map((field, idx) => {
                    if (
                      !field.custom_field_type?.active ||
                      field.custom_field_type?.field_type === 'note'
                    ) {
                      return null;
                    }

                    return (
                      <LeaseCustomField
                        key={startIndex + idx}
                        customField={field}
                        index={startIndex + idx}
                        basePath={basePath}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaseCustomFieldGroup;
